import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18bdf0b9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "manifold m-lazy-media lazy-iframe" }
const _hoisted_2 = ["src"]

import { inject, ref, watch } from 'vue';

interface LazyIframeProps {
  src: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LazyIframe',
  props: {
    src: {}
  },
  setup(__props: any) {



const { onLoad, onError }: any = inject('onLoadOnError');
const show = ref(false);
const error = ref(false);

watch(show, () => {
  if (show.value) {
    onLoad();
  }
});

watch(error, () => {
  if (error.value) {
    onError();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("iframe", {
      src: _ctx.src,
      ref: "frame",
      title: "listing-iframe",
      scroll: "",
      sandbox: "allow-same-origin allow-scripts allow-popups",
      allow: "camera; microphone; accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
    }, null, 8, _hoisted_2)
  ]))
}
}

})